import {nextTick, ref, computed} from 'vue'
import Velocity from 'velocity-animate'

export const useHandlers = (id, active, modal, data, currentSlide, content, container, offsetTop, offsetBottom, emit) => {
    const scrollY = ref(0)
    const duration = 0

    const currentSlideIndex = computed(() => currentSlide.value.index);

    const enableScroll = () => {
        document.body.style.position = ''
        document.body.style.top = ''
        document.body.style.width = ''
        window.scroll(0, scrollY.value)
    }

    const disableScroll = () => {
        if (document.body.style.position !== 'fixed') {
            scrollY.value = window.pageYOffset
            document.body.style.position = 'fixed'
            document.body.style.top = `-${scrollY.value}px`
            document.body.style.width = '100%'
        }
    }

    const openModal = async (payload) => {
        if (payload.id !== id) return

        active.value = true
        disableScroll()
        await nextTick(() => {
            if (modal.value) modal.value.focus()
        })

        if (data && payload.index !== undefined) {
            currentSlide.value = data[payload.index]
        }

        const modalContent = content.value

        if (modalContent && modalContent.update && typeof modalContent.update === 'function') {
            modalContent.update()
        }

        emit('open')
    }

    const closeModal = (payload) => {
        if (payload.id !== id) return
        active.value = false
        enableScroll()
        emit('close', payload)
    }

    const isPrev = (type) => {
        return type === 'prev' && currentSlideIndex.value !== 0
    }

    const isNext = (type) => {
        return type === 'next' && currentSlideIndex.value < data.length - 1
    }

    const changeSlide = (type) => {
        if (!data) return

        if (isPrev(type)) {
            currentSlide.value = data[currentSlideIndex.value - 1]
            emit('slide-change', { type: 'prev', slide: currentSlide.value })
        }

        if (isNext(type)) {
            currentSlide.value = data[currentSlideIndex.value + 1]
            emit('slide-change', { type: 'next', slide: currentSlide.value })
        }

        if (typeof type === 'object') {
            currentSlide.value = type
        }
    }

    const setOffsetValue = () => {
        const modalValue = modal.value
        const containerValue = container.value
        let offsetTopValue = 0
        let offsetBottomValue = 0

        modalValue ? offsetTopValue += parseFloat(getComputedStyle(modalValue).paddingTop) : offsetTopValue += 0
        modalValue ? offsetBottomValue += parseFloat(getComputedStyle(modalValue).paddingBottom) : offsetBottomValue += 0
        containerValue ? offsetTopValue += parseFloat(getComputedStyle(containerValue).paddingTop) : offsetTopValue += 0
        containerValue ? offsetBottomValue += parseFloat(getComputedStyle(containerValue).paddingBottom) : offsetBottomValue += 0

        offsetTop.value = offsetTopValue
        offsetBottom.value = offsetBottomValue
    }

    const appearAnimationBefore = (el) => {
        el.style.opacity = 0
    }

    const appearAnimationEnter = (el, done) => {
        Velocity(el, { opacity: 1 }, { duration: duration }, { complete: done })
    }

    const appearAnimationLeave = (el, done) => {
        Velocity(el, { opacity: 0 }, { duration: duration })
        Velocity(el, { display: 'none' }, { complete: done })
    }

    return {
        currentSlideIndex,
        openModal,
        closeModal,
        changeSlide,
        setOffsetValue,
        appearAnimationBefore,
        appearAnimationEnter,
        appearAnimationLeave,
        isPrev,
        isNext
    }
}
